export const packageName = 'Message Exchange Package';
export const packageNameAcronymn = 'MEP';
